import { DatenauswertungGenerisch } from '../../../bereiche/datenauswertung/DatenauswertungGenerisch';
import * as React from 'react';

interface VerbandslistePdfProps extends React.ClassAttributes<any> {
    jahrFirst: number;
    jahrLast: number;
    setRenderButton: (button: JSX.Element) => void;
    values: Array<any>;
    verband: any;
}

export class VerbandslistePdf extends React.Component<VerbandslistePdfProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    getConfig(): any {
        const numCols = 10;
        const baseWidth = 100 / numCols;
        const jahrFirst: number = this.props.jahrFirst || null;
        const jahrLast: number = this.props.jahrLast || null;

        return {
            titel0: (this.props.verband || {}).name || null,
            titel1: 'Jahresübersicht',
            titel2: jahrFirst < jahrLast ? `${jahrFirst} - ${jahrLast}` : `${jahrLast}`,
            filename: `Verbandsübersicht_${jahrFirst < jahrLast ? `${jahrFirst}_${jahrLast}` : jahrLast}.pdf`,
            baseWidth: baseWidth,
            header: {
                blocks: [
                    {
                        label: 'Bezeichnung',
                        width: `${baseWidth}%`,
                        customStyle: { minHeight: 15 }
                    },
                    ...Array.from(Array(9).keys()).map((index: number) => ({
                        label: `Spalte ${index + 2}`,
                        width: `${baseWidth}%`,
                        customStyle: { minHeight: 15 }
                    }))
                ]
            },
            rows: this.props.values || []
        };
    }

    render(): JSX.Element {
        return (
            <DatenauswertungGenerisch
                config={this.getConfig()}
                orientation='landscape'
                setRenderButton={(renderButton: JSX.Element) => this.props.setRenderButton(renderButton)}
            />
        );
    }
}